
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './App.css';

// Components
import AuthForm from './AuthForm';
import Dashboard from './Dashboard';
import LandingPage from './LandingPage';
import InOutSection from './InOutSection';
import Navbar from './NavBar';
import BucketList from './BucketList';
import GroupList from './GroupList';
import OnboardingForm from './OnboardingForm';
import ManifestationPage from './ManifestationPage';
import AuraCalculator from './AuraCalculator';
import CircleDetail from './CircleDetail';
import CreativeLoader from './CreativeLoader';
/* Updated ProtectedRoute in App.js */
// Simplified Guard
const AuthGuard = ({ children }) => {
  const { user, loading } = useAuth();
  const { uuid } = useParams();

  if (loading) return <div className="loading-screen" />;
  if (!user) return <Navigate to="/login" replace />;

  // Security: Block literal ":uuid" or wrong ID
  if (uuid === ':uuid' || (uuid && uuid !== user.uid)) {
    return <Navigate to="/" replace />;
  }

  return children;
};
export default function App() {
  const { user } = useAuth();

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }} >
      {user && <Navbar />}
      <Routes>
        {/* Public */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/landing" element={<CreativeLoader />} />
        <Route path="/login" element={<AuthForm />} />
        <Route path="/signup" element={<AuthForm initialMode />} />

        {/* Linear Protected Flow */}
        <Route path="/onboarding/:uuid" element={<AuthGuard><OnboardingForm /></AuthGuard>} />
        <Route path="/dashboard/:uuid" element={<AuthGuard><Dashboard /></AuthGuard>} />
        <Route path="/inout/:uuid" element={<AuthGuard><InOutSection /></AuthGuard>} />
        <Route path="/mylist/:uuid" element={<AuthGuard><BucketList /></AuthGuard>} />
        <Route path="/groupslist/:uuid" element={<AuthGuard><GroupList /></AuthGuard>} />
        <Route path="/groupslist/:circleId/:uuid" element={<AuthGuard><CircleDetail /></AuthGuard>} /> 
        <Route path="/manifestations/:uuid" element={<AuthGuard><ManifestationPage /></AuthGuard>} />
        <Route path="/aura/:uuid" element={<AuthGuard><AuraCalculator/></AuthGuard>}/>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}